import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { Experiments } from '../../Pages/Public/Experiments.js';
import { Experiment } from '../../Pages/Public/Experiment.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteExperiments = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [parks, setParks] = useState([]);
    const [exp, setExp] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest));
            const parks = await datasParks.json();
            setParks(parks);
            const dataExp = await fetch(`${backend}/nav/experiments`, GetHeaders(guest));
            const exp = await dataExp.json();
            setExp(exp);
        };
        fetchData();
    }, [backend, guest]);
    if (parks.err) window.location.href = '/';
    const navParks = FilterParkAndUnivers(parks);
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/experiences" element={<Experiments navParks={navParks} />} />
                {exp.map((el, i) => {
                    return (<Route path={el.route} element={<Experiment navParks={navParks} id={el.id} slug={el.slug} />} key={i} />)
                })}
                <Route path="*" element={<NotFound navParks={navParks} />} />
            </Routes>
        </BrowserRouter>
    )
}